import { Controller } from "@hotwired/stimulus"

export default class DemoFormController extends Controller {
  static targets = ["output"]
  static values = { field: String, kind: String }

  submit(event) {
    const values = new FormData(event.target).getAll(this.fieldValue).filter(Boolean)
    if (this.kindValue === "tags")
      this.outputTarget.textContent = values.length ? `Form value: ${values.join(", ")}` : "Form value: no tags."
    if (this.kindValue === "skills")
      this.outputTarget.textContent = `Selected skills: ${values.join(", ")}. Demo form complete.`
    if (this.kindValue === "directory")
      this.outputTarget.textContent = values.length ? `Selected IDs: ${values.join(", ")}` : "No people selected."
  }
}
